import { render, staticRenderFns } from "./TypeStateInsurance.vue?vue&type=template&id=6239ee68&scoped=true&"
import script from "./TypeStateInsurance.ts?vue&type=script&lang=ts&"
export * from "./TypeStateInsurance.ts?vue&type=script&lang=ts&"
import style0 from "./TypeStateInsurance.vue?vue&type=style&index=0&id=6239ee68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6239ee68",
  null
  
)

export default component.exports